import {DOCUMENT} from '@angular/common';
import {Component, Inject, NgZone, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Store} from '@ngrx/store';
import {CmsHelper, DeepLinkingUpdate} from '@ox/data';
import {AppBmls} from '@ox/typings';
import {AppConfigService} from '@ox/utils';
import {environment} from '../../environments/environment';
import {StylingService} from '../services/styling/styling.service';
const APP = 'PDP';

@Component({
  selector: 'pdp-entry',
  templateUrl: './entry.component.html'
})
export class RemoteEntryComponent implements OnInit {
  loaded = false;

  constructor(
    cms: CmsHelper,
    private store: Store,
    private config: AppConfigService,
    private activatedRoute: ActivatedRoute,
    private stylingService: StylingService,
    @Inject(DOCUMENT) private document: Document,
    ngZone: NgZone
  ) {
    ngZone.runOutsideAngular(() => {
      import('@ox/web-components');
    });
    cms.getRemoteContent(String(new AppBmls(environment.bmlMap).getId(this.config.bml.brand, this.config.bml.lang)), APP)
      .subscribe({
        next: (cmsLoaded: string) => this.loaded = cmsLoaded === APP
      });

    //shared nav
    const script = this.document.createElement('script');
    script.setAttribute('id', 'shop-nav');
    script.setAttribute('type', 'module');
    script.src = '/ecom/nav/build/gm-shared-nav.esm.js';
    this.document.head.prepend(script);

    const unifiedCSSLink = this.document.createElement('link');
    unifiedCSSLink.setAttribute('id', 'unifiedCSS');
    unifiedCSSLink.setAttribute('rel', 'stylesheet');
    unifiedCSSLink.href = 'assets/css/unified-shop.css';
    this.document.head.prepend(unifiedCSSLink);

    // PDP brand styling
    const brandStylesLink = this.document.createElement('link');
    brandStylesLink.setAttribute('id', 'gbds_css');
    brandStylesLink.setAttribute('rel', 'stylesheet');
    document.head.prepend(brandStylesLink);
    this.stylingService.setBrandCSS(this.config.bml.brand);
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => this.store.dispatch(DeepLinkingUpdate({queryParameters: params})));
  }
}

